import React from 'react'
import { css } from "glamor";
import { Divider, spacing, colors } from "../library";
import Menu from "../library/Menu";
import MenuItem from "../library/MenuItem";
import { Icon, Image } from "semantic-ui-react";

const menuTitleStyle = css({
  fontSize: 16,
  color: colors.greyDark,
  fontWeight: "bold",
  marginLeft: spacing.xs,
  marginBottom: spacing.xxs,
  letterSpacing: '2px',
});

const menuContainer = css({
  borderRadius: 8,
  "@media (min-width: 768px)": {
    minWidth: "280px",
    height: "100%",
    backgroundColor: colors.greyClear,
    padding: spacing.s,
  },
});

const menuItemDividerClass = css({
  "@media (min-width: 768px)": {
    display: "none",
  },
});

const menuItemImageClass = css({
  maxHeight: 66,
  objectFit: "cover",
  objectPosition: "100% 0",
  "@media (min-width: 768px)": {
    display: "none !important",
  },
}).toString();

const menuItemIconStyle = { marginBottom: spacing.s };

const menuItemNameStyle = {
  fontSize: 14,
  fontWeight: "600",
  color: "inherit",
  lineHeight: 1.5,
  flex: 1,
  marginRight: spacing.xs
};

const menuItemContentClass = css({
  display: "flex",
  alignItems: "center",
  gap: spacing.s,
});

const imageStyle = {
  width: 66
}

export default function DownloadsCourseMenu({
  courses,
  activeCourseId,
  handleCourseChange,
}) {
  return (
    <div className={menuContainer}>
      <p className={menuTitleStyle}>CURSOS</p>

      <Menu vertical>
        {courses.map((course) => (
          <div key={course.id}>
            <MenuItem
              name={course.id}
              active={activeCourseId === course.id}
              onClick={handleCourseChange}
            >
              <div className={menuItemContentClass}>
                <Image
                  className={menuItemImageClass}
                  src={course.imageUrl}
                  size="tiny"
                  square
                  rounded
                  style={imageStyle}
                />
                <p style={menuItemNameStyle}>{course.name}</p>
              </div>
              <Icon style={menuItemIconStyle} name="chevron right" />
            </MenuItem>
            <Divider className={menuItemDividerClass} />
          </div>
        ))}
      </Menu>
    </div>
  )
}
